// Function to spawn a new cloned object from the template with customizable width range
function spawnSpider(template, container, minWidth, maxWidth) {
    // Clone the template content
    const spiderClone = template.content.firstElementChild.cloneNode(true);

    // Set a random width between provided minWidth and maxWidth
    const randomWidth = Math.random() * (maxWidth - minWidth) + minWidth;
    spiderClone.style.width = `${randomWidth}rem`;

    // Calculate random left position (ensure it stays within viewport of container)
    const containerWidth = container.offsetWidth;
    const randomLeft = Math.random() * (containerWidth - (randomWidth * 16)); // Convert rem to pixels
    spiderClone.style.left = `${randomLeft}px`;

    // Append to the container
    container.appendChild(spiderClone);

    // Remove the spider clone after 3 seconds
    setTimeout(() => {
        spiderClone.remove();
    }, 3000);
}

// Function to run the spawnSpider function every 3 to 6 seconds for the halloween container
function startSpawning(template, halloweenContainer) {
    function repeatSpawn() {
        // Use the custom width range 4rem - 16rem for the halloween container
        spawnSpider(template, halloweenContainer, 4, 16);
        const randomInterval = Math.random() * (6000 - 3000) + 3000;
        setTimeout(repeatSpawn, randomInterval);
    }

    repeatSpawn();
}

// Function to randomly spawn on one of the event cards every 1.5 to 4.5 seconds with its own width range
function spawnOnEventCards(template, cardImageContainers) {
    function repeatCardSpawn() {
        const randomCard = cardImageContainers[Math.floor(Math.random() * cardImageContainers.length)];
        // Use the custom width range 4rem - 8rem for the event cards
        spawnSpider(template, randomCard, 4, 8);

        const randomInterval = Math.random() * (4500 - 1500) + 1500;
        setTimeout(repeatCardSpawn, randomInterval);
    }

    repeatCardSpawn();
}

window.addEventListener('load', () => {
    const halloweenContainer = document.querySelector('.halloween-theme .home-image-header-panel .background-container.z-4');
    const cardImageContainers = document.querySelectorAll('.halloween-theme .home-image-header-panel .event-card');
    const spiderTemplate = document.getElementById('ogSpider');

    if (halloweenContainer && spiderTemplate) {
        // Start spawning spiders in the halloweenContainer with the wider range
        startSpawning(spiderTemplate, halloweenContainer);

        // Start spawning spiders randomly on event cards with the smaller range
        if (cardImageContainers.length > 0) {
            spawnOnEventCards(spiderTemplate, cardImageContainers);
        }
    }
});
